// ** Initial State
const initialState = {
  allData: [],
  data: [],
  total: 1,
  params: {},
  selectedRecord: null
}

const record = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_DATA_ROLE':
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params
      }
    case 'GET_RECORD_ROLE':
      return { ...state, selectedRecord: action.selectedRecord }
    case 'ADD_RECORD_ROLE':
      return { ...state }
    case 'EDIT_RECORD_ROLE':
      return { ...state }  
    case 'DELETE_RECORD_ROLE':
      return { ...state }
    default:
      return { ...state }
  }
}
export default record
